import { render, staticRenderFns } from "./seniority.vue?vue&type=template&id=c6154552&scoped=true&"
import script from "./seniority.vue?vue&type=script&lang=js&"
export * from "./seniority.vue?vue&type=script&lang=js&"
import style0 from "./seniority.vue?vue&type=style&index=0&id=c6154552&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6154552",
  null
  
)

export default component.exports